export const loggedIn = (state) => state.app.loggedIn;